



















import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import SummaryInfoItems from '@/components/summary/SummaryInfoItems.vue'
import SummaryInfoServices from '@/components/summary/SummaryInfoServices.vue'
import SummaryInfoSignature from '@/components/summary/SummaryInfoSignature.vue'
import SignatureModal from '@/components/summary/SignatureModal.vue'
import {Task} from '@/store/types'

@Component({
  components: {
    AppHeader,
    AppFooter,
    SummaryInfoItems,
    SummaryInfoServices,
    SummaryInfoSignature,
    SignatureModal,
  },
})
export default class SummaryInfo extends Vue {
  @Getter('task') public task!: Task
  @Getter('showSignatureModal') public showSignatureModal!: boolean
  public back() {
    this.$router.back()
  }
}
